// ANCHOR React
import { useState } from 'react';

// ANCHOR Utils
import { tuple } from '@lyon/utils/tuple';

// ANCHOR Models
import createModel, { createSelector, createSelectors } from 'react-scoped-model';
import { useFormDataType } from '../FormData';

interface IProps {
  formQuestionId: string;
}

export const CreateFormQuestionAnswerForm = createModel(({ formQuestionId }: IProps) => {
  const formType = useFormDataType();

  const [name, setName] = useState<string>();
  const [feedback, setFeedback] = useState<string>();
  const [points, setPoints] = useState<string>(formType === 'quiz' ? '1' : '0');
  const [success, setSuccess] = useState(false);

  return {
    state: {
      name,
      feedback,
      points,
      success,
      formQuestionId,
    },
    handler: {
      name: setName,
      feedback: setFeedback,
      points: setPoints,
      success: setSuccess,
    },
  };
}, {
  displayName: 'Models.CreateFormQuestionAnswerForm',
});

export const useCreateFormQuestionAnswerFormPoints = createSelectors(
  CreateFormQuestionAnswerForm,
  ({ state, handler }) => tuple(
    state.points,
    handler.points,
  ),
);

export const useCreateFormQuestionAnswerFormName = createSelectors(
  CreateFormQuestionAnswerForm,
  ({ state, handler }) => tuple(
    state.name,
    handler.name,
  ),
);

export const useCreateFormQuestionAnswerFormSuccessValue = createSelector(
  CreateFormQuestionAnswerForm,
  ({ state }) => state.success,
);

export const useCreateFormQuestionAnswerFormSuccessDispatch = createSelector(
  CreateFormQuestionAnswerForm,
  ({ handler }) => handler.success,
);

export const useCreateFormQuestionAnswerFormSubmitPayload = createSelectors(
  CreateFormQuestionAnswerForm,
  ({ state }) => tuple(
    state.name,
    state.feedback,
    state.points,
    state.formQuestionId,
  ),
);
